import "./index.css";
import { Radio } from "../Radio";
import type { IRadioCardProps } from "./types";

export const RadioCard = ({
  disabled,
  radioPosition = "start",
  className,
  color = "layer2",
  ...radioProps
}: IRadioCardProps) => {
  const rootClassName = [
    "nuco-radio-card",
    `nuco-radio-card--${radioPosition}`,
    `nuco-radio-card--${color}`,
    disabled && "nuco-radio-card--disabled",
    className,
  ]
    .filter(Boolean)
    .join(" ");

  return (
    <Radio
      disabled={disabled}
      radioPosition={radioPosition}
      {...radioProps}
      className={rootClassName}
      isCard
      renderRadio={undefined}
    />
  );
};
